import dayjs from "dayjs";
import { z } from "zod";

/* eslint-disable no-useless-escape */
/** 8文字以上100文字以内の半角英数を含む */
export const passwordRegex = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i;

/** メールアドレス */
export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

/** url */
export const urlRegex = /https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+/g;

/** 半角数字 */
export const numRegex = /^[0-9]+$/;

export const oneStopServices = [
  "企画",
  "設営",
  "広告",
  "制作物",
  "喫煙所",
  "運営",
  "備品",
  "司会",
  "ごみ処理",
] as const;

export const inquirySchema = z.object({
  email: z
    .string({
      required_error: "Eメールアドレスの入力は必須です。",
    })
    .email("Eメールアドレスの形式が正しくありません。"),
  body: z
    .string({
      required_error: "お問い合わせの内容を入力してください。",
    })
    .min(1, "お問い合わせの内容を入力してください。"),
  /*
  googleReCaptchaToken: z
    .string({
      required_error: "Google ReCaptcha認証にチェックをしてください。"
    })
    .optional()
  */
});

function isValidDate(dateString: string) {
  try {
    return dayjs(dateString).isValid();
  } catch {
    return false;
  }
}

export const reservationSchema = z.object({
  groupName: z
    .string({
      required_error: "企業名・団体名は必須です。",
    })
    .min(1, "企業名・団体名は必須です。"),
  chargeName: z
    .string({
      required_error: "代表者名・担当者名は必須です。",
    })
    .min(1, "代表者名・担当者名は必須です。"),
  email: z
    .string({
      required_error: "Eメールアドレスの入力は必須です。",
    })
    .email("Eメールアドレスの形式が正しくありません。"),
  tel: z
    .string({
      required_error: "電話番号の入力は必須です。",
    })
    .regex(numRegex, "電話番号の形式が正しくありません。"),
  startDate: z
    .string({
      required_error: "開始日の入力は必須です。",
    })
    .min(1, "開始日の入力は必須です。")
    .refine((str) => isValidDate(str), "日付の形式が正しくありません。"),
  endDate: z
    .string({
      required_error: "終了日の入力は必須です。",
    })
    .min(1, "終了日の入力は必須です。")
    .refine((str) => isValidDate(str), "日付の入力が正しくありません。"),
  contents: z
    .string({
      required_error: "イベントの内容の入力は必須です。",
    })
    .min(1, "イベントの内容の入力は必須です。"),
  space: z
    .string({
      required_error: "希望スペースを選択してください",
    })
    .min(1, "希望スペースを選択してください"),
  oneStopServices: z.array(z.enum(oneStopServices), {}),
  publish: z
    .string({
      required_error: "ホームページへの掲載可否を選択してください。",
    })
    .min(1, "ホームページへの掲載可否を選択してください。"),
  note: z.string().optional(),
  /*
  googleReCaptchaToken: z.string().optional()
  */
});
